import {
  ApiBlueprint,
  PageBlueprint,
  createFrontendPlugin,
  FrontendFeature,
} from '@backstage/frontend-plugin-api';
import {
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { argoWorkflowsApiRef } from './api/ArgoWorkflowsApi';
import { ArgoWorkflowsClient } from './api/ArgoWorkflowsClient';
import { terraformPipelinesApiRef } from './api/TerraformPipelinesApi';
import { TerraformPipelinesClient } from './api/TerraformPipelinesClient';
import { ciPipelinesApiRef } from './api/CiPipelinesApi';
import { CiPipelinesClient } from './api/CiPipelinesClient';
import { CiPipelinesClientMock } from './api/CiPipelinesClientMock';

const argoWorkflowsApi = ApiBlueprint.make({
  params: define =>
    define({
      api: argoWorkflowsApiRef,
      deps: { fetchApi: fetchApiRef, discoveryApi: discoveryApiRef },
      factory: ({ fetchApi, discoveryApi }) =>
        new ArgoWorkflowsClient({ fetchApi, discoveryApi }),
    }),
});

const argoWorkflowsPage = PageBlueprint.make({
  params: {
    path: '/argo-workflows',
    loader: () =>
      import('./components/ArgoWorkflowsPage').then(m => <m.ArgoWorkflowsPage />),
  },
});

const terraformPipelinesApi = ApiBlueprint.make({
  name: 'terraform-pipelines',
  params: define =>
    define({
      api: terraformPipelinesApiRef,
      deps: { fetchApi: fetchApiRef, discoveryApi: discoveryApiRef },
      factory: ({ fetchApi, discoveryApi }) =>
        new TerraformPipelinesClient({ fetchApi, discoveryApi }),
    }),
});

const terraformPipelinesPage = PageBlueprint.make({
  name: 'terraform-pipelines',
  params: {
    path: '/terraform-pipelines',
    loader: () =>
      import('react-router-dom').then(({ Navigate }) => <Navigate to="/argo-workflows/iac" replace />),
  },
});

const IS_DEV = process.env.NODE_ENV === 'development';

const ciPipelinesApi = ApiBlueprint.make({
  name: 'ci-pipelines',
  params: define =>
    define({
      api: ciPipelinesApiRef,
      deps: { fetchApi: fetchApiRef, discoveryApi: discoveryApiRef },
      factory: ({ fetchApi, discoveryApi }) =>
        IS_DEV
          ? new CiPipelinesClientMock()
          : new CiPipelinesClient({ fetchApi, discoveryApi }),
    }),
});

const ciPipelinesPage = PageBlueprint.make({
  name: 'ci-pipelines',
  params: {
    path: '/ci',
    loader: () =>
      import('react-router-dom').then(({ Navigate }) => <Navigate to="/argo-workflows/ci" replace />),
  },
});

const argoWorkflowsEntityContent = EntityContentBlueprint.make({
  params: {
    path: 'argo-workflows',
    title: 'Workflows',
    loader: () =>
      import('./components/EntityArgoWorkflowsCard').then(m => (
        <m.EntityArgoWorkflowsCard />
      )),
    filter: 'metadata.annotations.argo-workflows.io/label-selector',
  },
});

export const argoWorkflowsPlugin: FrontendFeature = createFrontendPlugin({
  pluginId: 'argo-workflows',
  extensions: [
    argoWorkflowsApi,
    terraformPipelinesApi,
    ciPipelinesApi,
    argoWorkflowsPage,
    terraformPipelinesPage,
    ciPipelinesPage,
    argoWorkflowsEntityContent,
  ],
});

export default argoWorkflowsPlugin;
